import { createSecretOrgClient } from '@architeia/api-client'
import type { SecretOrgClient } from '@architeia/api-client'
import { useAuthStore } from '@/stores/auth'

/**
 * ORG-63 — the Secret Org API client for the signed-in member. The token is read from the auth
 * store on every request, so one client stays valid across token refreshes. Call it in `setup`
 * (it uses the Pinia store); do not call `createSecretOrgClient` directly anywhere else.
 */
export function useSecretOrgClient(): SecretOrgClient {
  const auth = useAuthStore()
  return createSecretOrgClient({ getAccessToken: () => auth.getAccessToken() })
}
